// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"aac5a341c9c5ac2e0798","655":"f092010efda3f9999c80"}[chunkId] + ".js";
};